import { Flex } from "antd"
import { ItemWorkareaData, ViewItem } from "./itemModel"
import { centsToDollarsDisplay, percentageDisplay } from "../displayFormatters"
import { PricingTypes, WorkareaItemType, WorkareaItemTypes } from "../../common/constants"
import { calculateActualSummary, calculateEstimateSummary } from "./workareaSummaryModel"
import { ItemsContext } from "./ItemsRoot"
import { useContext } from "react"
import { useCompletedWorkareaVisitsQuery } from "../../domain/invoicing/invoicingQueries"

type Props = {
  viewItems: ViewItem[]
  workareaItemType: WorkareaItemType
  quotedPrice?: number
  finalPrice?: number
  workarea: ItemWorkareaData
}

const WorkareaSummary = ({ viewItems, workareaItemType, quotedPrice, finalPrice, workarea }: Props) => {
  const { jobData: { jobId }, workareaSummaries, isPricingPending, isPricingError } = useContext(ItemsContext)
  const completedWorkareaVisitsQuery = useCompletedWorkareaVisitsQuery(jobId, workarea.pricingType === PricingTypes.PerVisit)
  const isEstimated = workareaItemType === WorkareaItemTypes.Estimated
  const pricedSummary = workarea.pricing ? workareaSummaries.find(x => x.workareaId === workarea.id) : undefined
  const effectivePrice = pricedSummary
    ? isEstimated ? pricedSummary.total : pricedSummary.finalPrice
    : quotedPrice
  const recovery = pricedSummary
    ? isEstimated ? pricedSummary.recovery : pricedSummary.actualRecovery
    : workarea.recovery
  const divideEstimate = pricedSummary && isEstimated && workarea.pricingType !== PricingTypes.PerVisit
    ? workarea.estimatedOccurrences ?? 1 : 1
  const summaryData = isEstimated
    ? calculateEstimateSummary(viewItems, pricedSummary ? (effectivePrice ?? 0) / (divideEstimate || 1) : effectivePrice, pricedSummary ? undefined : workarea.estimatedOccurrences, workarea.pricingType, (recovery ?? 0) / (divideEstimate || 1))
    : calculateActualSummary(viewItems, effectivePrice, workarea.pricingType, completedWorkareaVisitsQuery.data ?? [], workarea.id, recovery)

  return <Flex wrap="wrap" gap={10} align="center">
    <span>MATERIALS: <strong>{centsToDollarsDisplay(summaryData.materialsCostPlusTax)}</strong></span>
    {!isEstimated &&
      <span>FINAL PRICE: <strong>{isPricingPending ? 'Calculating…' : isPricingError ? 'Unavailable' : centsToDollarsDisplay(effectivePrice ?? finalPrice ?? 0)}</strong></span>
    }
    <span>GROSS PROFIT: <strong>{isPricingPending ? 'Calculating…' : isPricingError ? 'Unavailable' : percentageDisplay(summaryData.grossProfit * 100)}</strong></span>
  </Flex>
}

export default WorkareaSummary
